import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { hasDuplicateElementName } from './util';
import type { IFSM } from '../../../stores/model/metamodel/fsm';

/**
 * Check if an object type has duplicate FSMs (i.e. two FSMs with the same
 * name).
 */
class FSMDuplicateCheck extends Check<IFSM> {
  static description = 'Check for duplicate FSMs';

  check(): Report {
    this.report = new Report();
    const list = this.element.objectType.fsms;
    if (hasDuplicateElementName(list, this.element)) {
      this.report.addMessage(
        MessageType.ERROR,
        'FSMs with the same name found.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No FSMs with the same name found.',
        this,
        this.element
      );
    }
    return this.report;
  }
}

export default FSMDuplicateCheck;
